import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

const userSlice = createSlice({
  name: "user",
  initialState: null,
  reducers: {
    setUser: (_state, action) => action.payload,
    clearUser: () => null,
  },
});

export const getUser = (state: RootState) => state.user;
export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
